import { useQuery, UseQueryOptions } from '@tanstack/react-query'

import {
  getAllAssessmentRequirements,
  GetAllAssessmentRequirementsParams,
} from 'api/company/position/requirement/getAllAssessmentRequirements'
import { positionAssessmentLevelsKey } from './keys'

type AssessmentRequirementsData = Awaited<
  ReturnType<typeof getAllAssessmentRequirements>
>

export const useAllAssessmentRequirementsQuery = (
  params: GetAllAssessmentRequirementsParams = {},
  options?: UseQueryOptions<
    AssessmentRequirementsData,
    Error,
    AssessmentRequirementsData,
    ReturnType<typeof positionAssessmentLevelsKey>
  >
) => {
  return useQuery({
    ...options,
    queryKey: positionAssessmentLevelsKey(params),
    queryFn: () => getAllAssessmentRequirements(params),
  })
}
